import { render, staticRenderFns } from "./SignatureProtocole.vue?vue&type=template&id=2dafe210&"
import script from "./SignatureProtocole.vue?vue&type=script&lang=js&"
export * from "./SignatureProtocole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports